
import { controls } from "../../controls";

// function footerButtonsLogicDeposit(buttonName) {

let Savings_Regular = "f38ef10a-4ea0-11e3-9221-4c72b931b19d";
let Savings_Swift = "58ec36b4-39ee-4b7b-a9c9-3d4f3042a76d";
let Savings_No_Frill = "7d2d4dcc-9133-40c4-b8d0-18ed8e1584c7";

let Current = "e55b3b1d-0e63-4aee-89a5-618cdf8227dd";
let Current_Swift = "50e4d581-d192-47ff-8ad9-db20c995da37";

let Fixed_Deposit = "87e5be37-3150-4770-9cfb-91426aaafac2";
let Recurring_Deposit = "e7575178-fd21-4d7a-ba32-987e84fb62fa";
let Pension_Deposit = "90ac9793-3eb9-4302-bbc5-60a1dbf84b85";
let Reinvestment_Deposit = "501efb9e-62cd-4226-ba7e-87d564cdfec9";
let Call_Deposit = "75d72756-4e43-4e8d-8e6a-da63803990e3";
let Swift_Deposit = "20f71c58-ac91-4b7c-a2d3-1ea3fcc4d19f";

let Pigmy_Deposit = "d41e2746-5b2a-11e3-ad02-4c72b931b19d";

//   let definitions = {
//     // termdeposit: [Fixed_Deposit, Reinvestment_Deposit, Call_Deposit],
//     recurringdeposit: [Recurring_Deposit, Pension_Deposit],
//     pigmydeposit: [Pigmy_Deposit],

//   }
//   // check the product & whether in edit mode.
//   // console.log({mode})
//   // console.log(definitions[buttonName]);
//   return definitions[buttonName];
// }

const termdeposit = {
  label: "Term Deposite",
  pageLabel: "Term Deposite",
  starting: true,
  url: "termdeposit",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    {
      widths: "col-sm-6",
      title: "Deposit Details",
      parents: [
        {
          name: "product_type",
          match: "in",
          value: [Fixed_Deposit, Reinvestment_Deposit, Call_Deposit]
        }
      ],
      // style: { border: 0, paddingTop: 0 },
      subComponents: [

        ...controls.displayText({ label: "Interest Frequency", width: "col-sm-4" }),
        ...controls.IntFrequency({ width: "col-sm-4" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ width: "col-sm-4", label: "Receipt No" }),
        ...controls.numberOnly({ name: "receipt_no", width: "col-sm-4", placeHolder: "Receipt No" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.magicDateLabel({ width: "col-sm-4", star: true, label: "As on Date" }),
        ...controls.magicDate({ name: "as_on_date", width: "col-sm-4", default: "sessiondate", isRequired: true }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.magicDateLabel({ label: "Renewal Date", width: "col-sm-4" }),
        ...controls.magicDate({ dateType: "ontype", name: "renewal_date", width: "col-sm-4", default: "sessiondate" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Deposit Amount", width: "col-sm-4" }),
        ...controls.floatOnly({
          name: "deposit_amount", width: "col-sm-4"
        }),
        ...controls.showData({ data: "deposit_amount", displaytype: "in_words", width: "col-sm-4" }),


        ...controls.displayText({ width: "col-sm-4", label: "Deposit Period", star: true }),
        ...controls.displayText({ width: "col-sm-2", label: "Month", }),
        ...controls.numberOnly({ name: "deposit_period_month", width: "col-sm-2", isRequired: true }),
        ...controls.displayText({ label: "Days", width: "col-sm-1" }),
        ...controls.daysinterest({ width: "col-sm-2", isRequired: true }),
        ...controls.displayText({ width: "col-sm-1" }),

        ...controls.displayText({ width: "col-sm-4", label: "Interest Rate" }),
        ...controls.numberOnly({ name: "ints_rate", width: "col-sm-2", isReadOnly: true }),
        ...controls.displayText({ width: "col-sm-6" }),


        ...controls.checkBox({ label: "Auto Renew", name: "isAutorenew", width: "col-sm-6" }),
        ...controls.checkBox({ label: "Auto Renew With interest", name: "isAutorenewInterest", width: "col-sm-6" }),
      ]
    },
    {
      widths: "col-sm-6",
      title: "Maturity Details",
      parents: [
        {
          name: "product_type",
          match: "in",
          value: [Fixed_Deposit, Reinvestment_Deposit, Call_Deposit]
        }
      ],
      subComponents: [
        ...controls.displayText({ width: "col-sm-4", label: "Maturity Interest Transfer to", }),
        ...controls.text({ name: "maturity_interest_transfer_to", width: "col-sm-4", placeHolder: "Maturity Interest" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ width: "col-sm-4", label: "Standing Interest Transfer To" }),
        ...controls.text({ name: "maturity_interest_transfer_to", width: "col-sm-4", placeHolder: "Maturity Interest" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "GL Sub Head", width: "col-sm-4" }),
        ...controls.product({ width: "col-sm-4" }),
        ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-4" }),

        ...controls.displayText({ label: "Account Number", width: "col-sm-4" }),
        ...controls.AccountNumber({ tab: "termdeposit", width: "col-sm-4" }),
        ...controls.showData({ data: "account_number_display", name: "account_number_display", width: "col-sm-4" }),

        ...controls.magicDateLabel({ label: "Standing Due Date", width: "col-sm-4" }),
        ...controls.magicDate({ dateType: "ontype", name: "std_duedate", width: "col-sm-4" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Maturity Date", width: "col-sm-4" }),
        ...controls.showData({
          displaytype: 'date', data: "maturity_date", name: "maturity_date", width: "col-sm-4"
        }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Total Interest", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_total", displaytype: "currency", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_total", displaytype: "in_words", width: "col-sm-4" }),

        ...controls.displayText({ label: "Maturity Amount", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_amount_display", displaytype: "currency", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_amount_display", width: "col-sm-4", displaytype: "in_words" }),
      ]
    },
    {
      widths: "col-sm-12",
      tab: "termdeposit",
      title: "Interest Schedule",
      parents: [
        {
          name: "product_type",
          match: "in",
          value: [Fixed_Deposit, Reinvestment_Deposit, Call_Deposit]
        }
      ],
      subComponents: [
        // {
        //   inputType: "button",
        //   tab: "recurringdeposit",
        //   widths: {
        //     parent: "col-sm-6",
        //     children: "col-sm-12"
        //   },
        //   placeHolder: "",
        //   label: "save",
        //   onclick: {
        //     action: "handlesave",
        //     loadinto: "AllData"
        //   },
        //   name: "savechanges",
        //   Bcolor: "primary",
        //   size: "sm",
        //   style:{width:'145px'}
        // },
        {
          inputType: "table",
          tableTitle: "",
          // editable: true,
          // addRows: true,
          printable: true,
          // defaultValue:[{trdate:'',days:'',},{}],
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Date", isRequired: true, field: "trdate", displaytype: 'date', control: 'branch', width: 150 },
            { label: "Days", field: "days", control: 'text', displaytype: 'text' },
            { label: "Months", field: "months" },
            { label: "Interest", field: "interest", displaytype: 'currency' },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          description: "Interest Schedule Table",
          name: "intsche",
          // displayData: { ReadIntRate: "ints_rate",GetAddDate:'maturity_date',GenerateInterestSchedule:"intsche_table" },
          onRender: [
            // // sum last column of the current table
            { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.Deposits.intsche', field: 'interest' }, resultVar: 'totalInterest' },
            { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalInterest' }, { source: 'pageData.Deposits.deposit_amount' }], resultVar: 'total' },
            // // and set it as some other parentState.
            { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_amount_display", source: 'allResults', field: 'total' }, resultVar: "maturity_amount" },
            { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_total", source: 'allResults', field: 'totalInterest' }, resultVar: "maturity_total" },
            { f: 'setParentState', inputs: { dest: "pageData.interest_rate", source: 'pageData.Deposits.ints_rate', }, resultVar: "interest_rate" },

            // { f: 'dateOperations', inputs: [{ source: 'pageData.as_on_date', type: 'date' }, { source: 'pageData.Recurring.no_installments', type: 'months' }], resultVar: "maturity_date" },
            // { f: 'setParentState', inputs: { dest: "pageData.Recurring.maturity_date", source: 'allResults',field:'maturity_date' }, resultVar: "xyz" },

            // { f: 'setParentState', inputs: { dest:"pageData.Deposits.maturity_amount_display", source:'allResults',field: 'total', conditions:[{result:{type:"fixed",val:""},check:"neq", }] },resultVar:"maturity_amount" },
          ]
        },
      ]
    },
    {
      widths: "col-sm-12",
      tab: "termdeposit",
      title: "Recurring Deposite",
      parents: [
        {
          name: "product_type",
          match: "in",
          value: [Recurring_Deposit, Pension_Deposit]
        }
      ],
      subComponents: [
        ...controls.displayText({ label: "As On Date/Opening Date", width: "col-sm-2" }),
        {
          inputType: "showdata",
          tab: "recurringdeposit",
          displaytype: 'date',
          data: "as_on_date",
          textcolor: "black",
          name: "as_on_date",
          widths: {
            parent: "col-sm-4",
            children: "col-sm-12"
          },
        },
        ...controls.displayText({ width: "col-sm-6" }),

        {
          inputType: "displaytext",
          tab: "recurringdeposit",
          star: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Installment Amount",
          label: "Installment Amount",
          name: "",
          description: "Enter Installment Amount"
        },
        ...controls.floatOnly({
          name: "deposit_amount", width: "col-sm-4"
        }),
        ...controls.showData({ data: "deposit_amount", displaytype: "in_words", width: "col-sm-4" }),
        ...controls.displayText({ width: "col-sm-2" }),
        ...controls.displayText({ tab: "recurringdeposit", label: "No Of Installment", width: "col-sm-2" }),

        ...controls.numberofinstallment({ tab: "recurringdeposit" }),
        ...controls.displayText({ width: "col-sm-6" }),

        {
          inputType: "displaytext",
          tab: "recurringdeposit",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maturity Date",
          name: "",
          description: ""
        },
        ...controls.showData({
          displaytype: 'date', data: "maturity_date", name: "maturity_date", width: "col-sm-4", parents: [
            {
              name: "Deposits.deposit_period_month",
              match: "exist",
              show: 'blank'
            }
          ],
        }),
      
        ...controls.displayText({ width: "col-sm-6" }),
        ...controls.displayText({ width: "col-sm-2", label: "Interest Rate" }),
        ...controls.numberOnly({ name: "ints_rate", width: "col-sm-2", isReadOnly: true }),
        ...controls.displayText({ width: "col-sm-8" }),
        ...controls.displayText({ width: "col-sm-2", label: "Maturity Amount" }),
        ...controls.showData({ data: "maturity_amount_display", displaytype: "currency", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_amount_display", width: "col-sm-4", displaytype: "in_words" }),

        // {
        //   inputType: "showdata",
        //   tab: "recurringdeposit",
        //   data: "maturity_amount_rd",
        //   displaytype:'currency',
        //   name:"maturity_amount_rd",
        //   textcolor: "black",
        //   widths: {
        //     parent: "col-sm-4",
        //     children: "col-sm-12"
        //   },
        //   parents: [
        //     {
        //       name: "Deposits.no_of_installment",
        //       match: "exist",
        //       show:'blank'
        //     }
        //   ],
        // },
      ]

    },
    {
      widths: "col-sm-12",
      tab: "termdeposit",
      title: "Interest Schedule",
      parents: [
        {
          name: "product_type",
          match: "in",
          value: [Recurring_Deposit, Pension_Deposit]
        }
      ],
      subComponents: [
        {
          inputType: "table",
          tableTitle: "",
          editable: true,
          printable: true,
          // defaultValue:[{trdate:'',days:'',},{}],
          tableHeaders: [
            { label: "Sr", type: "srno" },
            { label: "Date", isRequired: true, field: "trdate", displaytype: 'date', control: 'branch', width: 150 },
            { label: "Days", field: "days", control: 'text', displaytype: 'text' },
            { label: "Months", field: "months" },
            { label: "Interest", field: "interest", displaytype: 'currency' },
            { label: "acctguid", field: "acctguid", display:"none" ,defaultVal:{type:"var",value:"pageData.unique_id"}}
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          description: "Interest Schedule Table",
          name: "intsche",
          // displayData: { ReadIntRate: "ints_rate",GetAddDate:'maturity_date',GenerateInterestSchedule:"intsche_table" },
          onRender: [
            // // sum last column of the current table
            { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.Deposits.intsche', field: 'interest' }, resultVar: 'totalInterest' },
            { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_total_rd", source: 'allResults', field: 'totalInterest' }, resultVar: "abc" },

            // { f: 'simpleArithmatic',calcType:'sum', inputs: [{source:'allResults', field: 'totalInterest'}, { source: 'pageData.Deposits.deposit_amount' }], resultVar: 'total' },
            // // and set it as some other parentState.
            // { f: 'setParentState', inputs: { dest:"pageData.Deposits.maturity_amount_display", source:'allResults',field: 'total' },resultVar:"maturity_amount" },

            { f: 'dateOperations', inputs: [{ source: 'pageData.account_opening_date', type: 'date' }, { source: 'pageData.Deposits.deposit_period_month', type: 'months' }], resultVar: "maturity_date" },
            // { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_date", source: 'allResults', field: 'maturity_date' }, resultVar: "xyz" },

            { f: 'setParentState', inputs: { dest: "pageData.interest_rate", source: 'pageData.Deposits.ints_rate', }, resultVar: "interest_rate" },

            { f: 'setParentState', inputs: { dest: "pageData.Deposits.as_on_date", source: 'pageData.account_opening_date' }, resultVar: "abcd" },

          ]
        },

        ...controls.displayText({ label: "Total Interest", width: "col-sm-2" }),

        {
          inputType: "showdata",
          displaytype: 'currency',
          data: "maturity_total_rd",
          textcolor: "black",
          name: "maturity_total_rd",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          }
        },

      ]
    }



  ]
}

export default termdeposit;